<template lang="pug">
.search-teacher
  textbox-search.search-teacher__action(v-model='fullNameValue', :placeholder='fullNamePlaceholder')
  textbox-search.search-teacher__action(
    v-if='isAdmin',
    v-model='academyNameValue',
    :placeholder='academyNamePlaceholder'
  )
  textbox-search.search-teacher__action(
    v-if='isAcademy || isAdmin',
    v-model='branchNameValue',
    :placeholder='branchNamePlaceholder'
  )
  pulldown-select.search-teacher__action(v-model='authorityValue', :selectOptions='authoritySelectOptions')
  button-search.search-teacher__action(@click='searchEvent')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextboxSearch from '@/components/molecules/manager/TextboxSearch.vue'
import PulldownSelect from '@/components/molecules/manager/PulldownSelect.vue'
import ButtonSearch from '@/components/molecules/manager/ButtonSearch.vue'
import { UserRoles, UserRoleSettings } from '@/const/UserRoles'
import { InputItem } from '@/models/inputItem'

/**
 * 教室絞り込み
 */
@Component({
  components: {
    TextboxSearch,
    PulldownSelect,
    ButtonSearch,
  },
})
export default class SearchTeacher extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // 氏名
  @Prop()
  fullName!: string

  //  塾名（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyName?: string

  // 教室名(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchName?: string

  // 権限
  @Prop()
  authority!: string

  // 氏名プレースホルダー
  @Prop()
  fullNamePlaceholder!: string

  // 塾名プレースホルダー（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNamePlaceholder?: string

  // 教室名プレースホルダー(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchNamePlaceholder?: string

  // 権限プレースホルダー
  @Prop()
  authorityPlaceholder!: InputItem

  // 氏名変更時のイベント
  @Prop()
  fullNameChangeEvent!: Function

  // 塾名変更時のイベント（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNameChangeEvent?: Function

  // 教室名変更時のイベント(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchNameChangeEvent?: Function

  // 権限変更時のイベント
  @Prop()
  authorityChangeEvent!: Function

  // 検索イベント
  @Prop()
  searchEvent!: Function

  /*
   * 入力値ゲッター・セッター
   */
  // 氏名
  get fullNameValue(): string {
    return this.fullName
  }
  set fullNameValue(value: string) {
    this.fullNameChangeEvent(value)
  }
  // 塾名
  get academyNameValue(): string {
    return this.academyName || ''
  }
  set academyNameValue(value: string) {
    if (this.academyNameChangeEvent) {
      this.academyNameChangeEvent(value)
    }
  }
  // 教室名
  get branchNameValue(): string {
    return this.branchName || ''
  }
  set branchNameValue(value: string) {
    if (this.branchNameChangeEvent) {
      this.branchNameChangeEvent(value)
    }
  }
  // 権限
  get authorityValue(): string {
    return this.authority
  }
  set authorityValue(value: string) {
    this.authorityChangeEvent(value)
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // 塾管理者であるか
  private get isAcademy(): boolean {
    return this.userRole === UserRoles.ACADEMY
  }

  // ログインユーザ権限から選択可能なユーザ権限一覧を取得、権限プルダウンを生成する
  private get authoritySelectOptions(): InputItem[] {
    const configurable = UserRoleSettings.findConfigurableByRole(this.userRole)
    const options = [this.authorityPlaceholder]

    return options.concat(
      configurable.map((roleSetting) => {
        return { value: String(roleSetting.role), label: roleSetting.name }
      })
    )
  }
}
</script>

<style lang="stylus" scoped>
.search-teacher
  display flex

  &__action
    margin 7px 5px
</style>
